'use strict'
export default {
   data:'转载请说明出处：中思拓研究院'
}